import React from 'react';

interface Props {}

const ArrowUpBig = (props: Props) => {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.5 8.5L6 2.5L0.5 8.5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};
export default ArrowUpBig;
